import { Injectable } from '@angular/core';
import { CampaignService } from '@shared/api-services/campaign.service';
import { MDActivationCodeService } from '@shared/api-services/MD-activation-code.service';
import { OutletInfoService } from '@shared/api-services/outlet-info.service';
import { WarehouseSaleService } from '@shared/api-services/warehouse-sale.service';
import { AppConsts } from '@shared/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';
import * as FileSaver from 'file-saver';

@Injectable()
export class FileDownloadService {

    constructor(private _partnerFileService: OutletInfoService,
        private _campaignFileService: CampaignService,
        private _warehouseFileService: WarehouseSaleService,
        private _MDFileService: MDActivationCodeService

    ) { }

    private saveBlob(blob: Blob, fileName: string) {
        FileSaver.saveAs(blob, fileName);
    }

    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile?fileType=' + file.fileType + '&fileToken=' + file.fileToken + '&fileName=' + file.fileName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }

    downloadTemplate(templateName) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTemplateExcel?templateName=' + templateName;
        location.href = url; //TODO: This causes reloading of same page in Firefox
    }


    downloadFileNew(file: FileDto, source?: string | 'partner' | 'campaign' | 'warehouse' | 'request' | 'MD') {
        switch (source) {
            case 'partner': this._partnerFileService.downloadTempFile(file.fileName, file.fileType, file.fileToken)
                .subscribe({
                    next: (blob) => {
                        this.saveBlob(blob, file.fileName);
                    },
                    error: (err) => console.error('Download failed:', err)
                });
                break;
            case 'campaign': this._campaignFileService.downloadTempFile(file.fileName, file.fileType, file.fileToken)
                .subscribe({
                    next: (blob) => {
                        this.saveBlob(blob, file.fileName);
                    },
                    error: (err) => console.error('Download failed:', err)
                });
                break;
            case 'warehouse': this._warehouseFileService.downloadTempFile(file.fileName, file.fileType, file.fileToken)
                .subscribe({
                    next: (blob) => {
                        this.saveBlob(blob, file.fileName);
                    },
                    error: (err) => console.error('Download failed:', err)
                });
                break;
            case 'MD': this._MDFileService.downloadTempFile(file.fileName, file.fileType, file.fileToken)
                .subscribe({
                    next: (blob) => {
                        this.saveBlob(blob, file.fileName);
                    },
                    error: (err) => console.error('Download failed:', err)
                });
                break;
            default: this.downloadTempFile(file);
                
                break;
        }

    }


    downloadFileFromBase64(file: { fileContent?: string, fileName: string, fileType: string, fileToken?: string }, source:string) {
        if (file.fileContent) {
            const byteChars = atob(file.fileContent);
            const byteNumbers = new Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) {
                byteNumbers[i] = byteChars.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: file.fileType });

            this.saveBlob(blob, file.fileName);
        } else if (file.fileToken) {
            this.downloadFileNew(file as FileDto, source);
        } else {
            console.warn('No fileContent or fileToken found to download.');
        }
    }
}
